
import React, { useState, useEffect } from 'react';
import './About.css';

// Helper function to shuffle an array
const shuffleArray = (array) => {
  let currentIndex = array.length, randomIndex;
  while (currentIndex !== 0) {
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;
    [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
  }
  return array;
};

function About() {
  const [animatedCovers, setAnimatedCovers] = useState([]);

  useEffect(() => {
    fetch('https://backend.viralphonks.com:443/songs')
      .then(response => response.json())
      .then(data => {
        const selectedSongs = shuffleArray(data).slice(0, 8);
        const placedPositions = [];
        const minDistance = 20; // Minimum distance in vh/vw units
        const centralNoGoZone = { top: 25, bottom: 75, left: 25, right: 75 };

        const covers = selectedSongs.map(song => {
          let position = {};
          let isValidPosition = false;
          let attempts = 0;

          while (!isValidPosition && attempts < 100) {
            isValidPosition = true;
            position = {
              top: Math.random() * 85 + 5, // 5vh to 90vh
              left: Math.random() * 85 + 5, // 5vw to 90vw
            };

            // Check if it's in the central no-go zone
            if (position.top > centralNoGoZone.top && position.top < centralNoGoZone.bottom &&
                position.left > centralNoGoZone.left && position.left < centralNoGoZone.right) {
              isValidPosition = false;
              attempts++;
              continue;
            }

            // Check for collisions with already placed covers
            for (const p of placedPositions) {
              const dist = Math.sqrt(Math.pow(p.top - position.top, 2) + Math.pow(p.left - position.left, 2));
              if (dist < minDistance) {
                isValidPosition = false;
                break;
              }
            }
            attempts++;
          }

          if (isValidPosition) {
              placedPositions.push(position);
          }

          return {
            id: song.id,
            imageUrl: song.cover_image_url,
            style: {
              top: `${position.top}vh`,
              left: `${position.left}vw`,
              animationDuration: `${Math.random() * 10 + 15}s`,
              animationDelay: `-${Math.random() * 5}s`,
            }
          };
        });

        setAnimatedCovers(covers);
      })
      .catch(error => console.error('Error fetching songs for background:', error));
  }, []);

  return (
    <div className="about-container">
      <div className="background-animation">
        {animatedCovers.map(cover => (
          <div key={cover.id} className="floating-cover" style={cover.style}>
            <img src={cover.imageUrl} alt="" />
          </div>
        ))}
      </div>
      <div className="about-content">
        <div className="about-box">
          <h1>Hakkımızda</h1>
          <p>
            Merhaba, benim bu sitede amacım editlerde kullanılan popüler phonk şarkılarını kolay ve erişilebilir kılmaktır.
            Sitemizdeki tüm şarkıların normal, yavaşlatılmış (slowed) ve süper yavaşlatılmış (super slowed)
            versiyonlarına erişebilirsiniz.
          </p>
          <p>
            Ben harunege217, E-mail: hegek217@gmail.com, Discord Name|Server: harunege217 | https://discord.gg/cGAuPujurd
            Bana buralardan ulaşabilirsiniz.
          </p>
        </div>
      </div>
    </div>
  );
}

export default About;
